<script setup lang="ts">
import { computed, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import { addSizeToDataLayer } from "@/functions/analytics";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";

import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'circle', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

document.addEventListener('focusin', (event) => store.commit('updateFocusedElement', event));
document.addEventListener('focusout', () => store.commit('updateFocusedElement', ''));

onBeforeUnmount(() => {
	document.removeEventListener('focusout', () => store.commit('updateFocusedElement'));
	document.removeEventListener('focusin', () => store.commit('updateFocusedElement'));
});

const diameter = computed({
	get: () => dimensions.value.diameter,
	set: (value: string) => {
		store.dispatch( action, {
			dimension: "diameter",
			value: value,
		});
	},
});
</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="circle-diameter"
			:id="`${prefix}measurements-circle-diameter`"
			:name="`${prefix}measurements[dimensions][diameter]`"
			unit="cm"
			:label="dimensionLabel('diameter', 'circle')"
			:instructions="isCutout ? '' : dimensionMaxLabel('diameter')"
			:invalid="!isDimensionValid(`${prefix}circle-diameter`)"
			:onBlur="() => addSizeToDataLayer('diameter', +diameter, 'circle')"
			v-model="diameter"
		/>
	</shape-input-fields-wrapper>
</template>
